// React
import React, { useState, useEffect } from "react";

// Flex Layout
import { Spinner, Form } from "react-bootstrap";
import "react-simple-flex-grid/lib/main.css";

import { Button, Menu, Dropdown } from "antd";
import {
  BranchesOutlined,
  DownloadOutlined,
  DeleteOutlined,
  EditOutlined,
  UploadOutlined,
  MoreOutlined,
  TagOutlined,
  CalendarOutlined,
  UserOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  TeamOutlined
} from "@ant-design/icons";

// Screenshot
// import html2canvas from "html2canvas";

// Eventify API
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";
// import { func } from "prop-types";

// Components
import ListTable from "../components/ListTable";
import ListSidePane from "../components/ListSidePane";
import ListTagsTypeahead from "../components/ListTagsTypeahead";
import InviteImageUpload from "../components/InviteImageUpload";
import ListHistoryFeed from "../components/ListHistoryFeed";

import DatePicker from "react-datepicker";

export default function ListContainer(props) {
  let currentListId = props.listid;

  const [listContent, setListContent] = useState([]);
  const [apiResponseList, setAPIResponseList] = useState({});
  const [creator, setCreator] = useState({});
  const [showSidePane, setShowSidePane] = useState(true);
  const [savingListName, setSavingListName] = useState(false);
  const [stateListName, setStateListName] = useState("");

  const [headcount, setHeadcount] = useState(0);
  const [numapproved, setNumapproved] = useState(0);
  const [numremoved, setNumremoved] = useState(0);

  const [primaryListDate, setPrimaryListDate] = useState(new Date());

  const listTagsTypeaheadRef = React.useRef();
  const listTableRef = React.useRef();
  const listSidePaneRef = React.useRef();
  const listHistoryFeedRef = React.useRef();

  var currentListName = "";

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    if (currentListId != null) {
      fetchListWithId(currentListId);
      if (listTagsTypeaheadRef.current != null) {
        listTagsTypeaheadRef.current.listSelectionChanged();
      }

      if (listHistoryFeedRef.current != null) {
        listHistoryFeedRef.current.setCurrentListId(currentListId);
      }
    }
  }

  function listEditButtonAction() {
    props.listEditModalAction(currentListId);
  }

  function listCompareButtonAction() {
    props.listCompareModalAction(currentListId);
  }

  function handleListResponse(result, listid) {
    setStateListName(result.name);
    setAPIResponseList(result);

    const list = result;
    if (typeof list !== "undefined") {
      getListCreator(list.userid);

      // if (listTableRef.current != null) {
      //   listTableRef.current.setCurrentListId(listid);
      //   console.log(list);
      //   console.log(list.length);
      // }

      if (typeof list.primaryDate !== "undefined") {
        setPrimaryListDate(new Date(list.primaryDate));
      }
    }
  }

  function refreshHistory() {
    if (listHistoryFeedRef != null && typeof listHistoryFeedRef.current !== "undefined") {
      listHistoryFeedRef.current.setCurrentListId(currentListId);
    }
  }

  async function fetchListWithId(listid) {
    ModelCache.getListForId(listid, result => {
      handleListResponse(result, listid);
      if (listHistoryFeedRef.current) {
        listHistoryFeedRef.current.setCurrentListId(listid);
      }
    });
  }

  function currentListCallback() {
    return { listid: currentListId, listName: currentListName };
  }

  function getListCreator(userid) {
    ModelCache.getUserById(userid, user => {
      if (user != null && typeof user !== "undefined") {
        setCreator(user);
      }
    });
  }

  // TODO
  function showDetailPanelForPersonId(personid) {
    if (listSidePaneRef.current != null) {
      listSidePaneRef.current.handleShowImperative(personid);
    }
  }

  function setListStats(stats) {
    setHeadcount(parseInt(stats.headcount || 0));
    setNumapproved(parseInt(stats.pendingApprovals || 0));
    setNumremoved(parseInt(stats.pendingRemovals || 0));
  }

  function userChangedPrimaryDate(date) {
    setPrimaryListDate(date);
    const unixTime = new Date(date).getTime();
    EventifyAPI.setPrimaryDateForList(currentListId, unixTime);
  }

  const listNameInputRef = React.useRef();

  var timeoutId;
  var capture = "";
  function listNameChanged() {
    console.log(listNameInputRef.current.value);
    capture = listNameInputRef.current.value;
    setStateListName(capture);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function() {
      EventifyAPI.setPropertyOfList(currentListId, {
        name: capture
      }).then(result => {});
    }, 750);
  }

  function saveToComputer(thingToSave, type) {
    var file = new Blob([thingToSave], { type: type });
    var a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = currentListName + ".csv";
    document.body.appendChild(a);
    a.click();
    setTimeout(function() {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  async function moreMenuSelection(item) {
    console.log(item.key);

    const persons = listTableRef.current.exportList();

    const list = listContent;

    var type = "";
    var thingToSave = null;

    if (item.key === "paperless") {
      let finalList = [];
      const entry = ["Name", "Email"].join(",");
      finalList.push(entry);

      console.log(persons);
      for (let idx = 0; idx < persons.length; idx++) {
        const person = persons[idx];

        const name = person.name;
        const email = person.membership?.contactEmail || person.email || "";

        const entry = [
          person.name,
          person.email,
        ].join(",");
        finalList.push(entry);
      }
      thingToSave = finalList.join("\n");
      type = "csv";
      saveToComputer(thingToSave, type);
    } else if (item.key === "download_csv") {
      let finalList = [];
      const entry = ["Name", "Email", "Notes", "Added By"].join(",");
      finalList.push(entry);

      console.log(persons);
      for (let idx = 0; idx < persons.length; idx++) {
        const person = persons[idx];

        const name = person.name;
        const email = person.membership?.contactEmail || person.email || "";
        const notes = person.notes?.notes || "";
        const addedBy = person.membership?.suggestor;

        const entry = [
          person.name,
          person.email,
          notes,
          addedBy
        ].join(",");
        finalList.push(entry);
      }
      thingToSave = finalList.join("\n");
      type = "csv";
      saveToComputer(thingToSave, type);
    } else if (item.key === "print") {
      // html2canvas(document.querySelector("#tableBody"))
      //    .then(function (canvas) {
      //       document.body.appendChild(canvas);
      //       var base64URL = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');
      //       //
      //    });
    } else if (item.key === "upload_ynp") {
      props.showYNPUploadModal();
    } else if (item.key === "delete") {
      window.confirm("Are you sure you want to delete this list?");
      await EventifyAPI.deleteList(currentListId);
      window.open("/lists");
    }
  }

  const exportMenu = (
    <Menu onClick={moreMenuSelection}>
      <Menu.Item key="download_csv">
        <a target="_blank" rel="noopener noreferrer">
          <DownloadOutlined />
          Export CSV
        </a>
      </Menu.Item>
      <Menu.Item key="paperless">
        <a target="_blank" rel="noopener noreferrer">
          <DownloadOutlined />
          Export CSV For Paperless Post
        </a>
      </Menu.Item>
      {/*}<Menu.Item>
        <a target="_blank" rel="noopener noreferrer">
          <Icon type="download_print" />
          Print
        </a>
      </Menu.Item>*/}
      <Menu.Item key="upload_ynp">
        <a target="_blank" rel="noopener noreferrer">
          <UploadOutlined />
          Upload YNP From Paperless Post
        </a>
      </Menu.Item>
      <Menu.Item key="delete">
        <a target="_blank" rel="noopener noreferrer">
          <DeleteOutlined />
          Delete
        </a>
      </Menu.Item>
    </Menu>
  );

  function uploadCSVAction() {
    props.showUploadListModal(currentListId);
  }

  var localListContent = [];

  function renderList(list) {
    if (list === null || typeof list === "undefined") {
      return <></>;
    }

    currentListName = list.name;

    if (list.name === null || typeof list.name === "undefined") {
      return <></>;
    } else {
      return (
        <div className={"custom-table-container"}>
          <div className="table-details-name">
            <div className="detail-container">
              <div
                className="list-name"
                key={"name_" + list.listid}
                listkey={list.listid}
              >
                <Spinner
                  animation="border"
                  className={`${savingListName == true ? "" : " hidden"}`}
                />
                <Form.Control
                  ref={listNameInputRef}
                  placeholder="List Name"
                  onChange={listNameChanged}
                  value={stateListName}
                />
              </div>
              <div className="listBatchActions">
                <div className="content-container">
                  <Button
                    type="link"
                    icon={<EditOutlined />}
                    onClick={listEditButtonAction}
                  >
                    Edit
                  </Button>
                  <Button type="link" onClick={listCompareButtonAction}>
                    <BranchesOutlined />
                    Compare
                  </Button>
                  <Button type="link" onClick={uploadCSVAction}>
                    Upload CSV
                  </Button>

                  <Dropdown
                    className="more-dots"
                    overlay={exportMenu}
                    type="link"
                  >
                    <Button type="link">
                      <MoreOutlined />
                    </Button>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="table-details">
            <div className="detail-container">
              <div className="list-detail">
                <p className="label">
                  <UserOutlined />
                  Owner
                </p>
                <div className="detail-data">
                  {creator.fullName != null ? creator.fullName : creator.email}
                </div>
              </div>

              <div className="list-detail">
                <p className="label">
                  <CalendarOutlined />
                  Date of Event
                </p>

                <div className="detail-data">
                  <DatePicker
                    selected={primaryListDate}
                    onChange={userChangedPrimaryDate}
                  />
                </div>
              </div>

              <div className="list-detail">
                <p className="label">
                  <TagOutlined />
                  Tags
                </p>
                <div className="detail-data">
                  <ListTagsTypeahead
                    email={props.email}
                    organizationid={props.organizationid}
                    currentListCallback={currentListCallback}
                    ref={listTagsTypeaheadRef}
                    isSearchMode={false}
                  />
                </div>
              </div>
            </div>

            <div className="detail-container">
              <div className="list-detail">
                <p className="label">
                  <TeamOutlined />
                  List Size
                </p>
                <div className="detail-data">
                  <p className="number">{headcount}</p>
                </div>
              </div>
              <div className="list-detail">
                <p className="label">
                  <UserAddOutlined />
                  Pending Approval
                </p>
                <div className="detail-data">
                  <p className="number approval-number">{numapproved}</p>
                </div>
              </div>
              <div className="list-detail">
                <p className="label">
                  <UserDeleteOutlined />
                  Pending Removal
                </p>
                <div className="detail-data">
                  <p className="number removal-number">{numremoved}</p>
                </div>
              </div>
            </div>

          </div>
          <ListTable
            ref={listTableRef}
            list={list}
            refreshHistory={refreshHistory}
            setListStats={setListStats}
          />
        </div>
      );
    }
  }

  return (
    <div className="active main-panel">
      <div className="column-left">
        <div className="custom-table-content-container">
          {renderList(apiResponseList)}
        </div>
      </div>

      <div className="column-right">
        <InviteImageUpload
          email={props.email}
          organizationid={props.organizationid}
          listid={currentListId}
          list={apiResponseList}
        />
        <ListHistoryFeed
          ref={listHistoryFeedRef}
          email={props.email}
          organizationid={props.organizationid}
          listid={currentListId}
        />
      </div>
      <ListSidePane
        ref={listSidePaneRef}
        email={props.email}
        organizationid={props.organizationid}
        currentListCallback={currentListCallback}
      />
    </div>
  );
}
